// Mock data for Tatva Wellness Center

export const LOGO_URL = "/assets/tatva-logo.png";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=2000&q=80";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Treatments", href: "#treatments" },
  { label: "Our Team", href: "#team" },
  { label: "Contact Us", href: "#book" },
];

export const MARQUEE_ITEMS = [
  "Acupuncture",
  "Hydrotherapy",
  "Ozone Therapy",
  "Physiotherapy",
  "Cupping",
  "Marma Therapy",
  "Massages",
  "Chiropractic",
];

export const PILLARS = [
  {
    title: "Physical",
    desc: "Body-centred naturopathic care",
    icon: "Activity",
  },
  {
    title: "Mental",
    desc: "Clarity, focus and calm restored",
    icon: "Brain",
  },
  {
    title: "Emotional",
    desc: "Deep emotional rebalancing",
    icon: "HeartPulse",
  },
  {
    title: "Holistic",
    desc: "Whole-person wellness approach",
    icon: "Sprout",
  },
];

export const TREATMENTS = [
  {
    title: "Acupuncture",
    subtitle: "Electro acupuncture · Moxa therapy",
    image:
      "https://images.unsplash.com/photo-1598555763574-dca77e10427e?auto=format&fit=crop&w=1200&q=80",
    icon: "Waves",
  },
  {
    title: "Chiropractic",
    subtitle: "Spinal alignment & joint care",
    image:
      "https://images.unsplash.com/photo-1706353399656-210cca727a33?auto=format&fit=crop&w=1200&q=80",
    icon: "Bone",
  },
  {
    title: "Marma Therapy",
    subtitle: "Ancient vital-point healing",
    image:
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?auto=format&fit=crop&w=1200&q=80",
    icon: "Flower2",
  },
  {
    title: "Hydrotherapy",
    subtitle: "Enema · Hip bath · Steam bath · Spinal spray",
    image:
      "https://images.unsplash.com/photo-1541689186060-3b08be2fd22f?auto=format&fit=crop&w=1200&q=80",
    icon: "Droplets",
  },
  {
    title: "Physiotherapy",
    subtitle: "IFT · Ultrasound · TENS · Joint manipulation",
    image:
      "https://images.unsplash.com/photo-1649751361457-01d3a696c7e6?auto=format&fit=crop&w=1200&q=80",
    icon: "Dumbbell",
  },
  {
    title: "Cupping",
    subtitle: "Wet · Fire · Dry cupping",
    image:
      "https://images.unsplash.com/photo-1745327883389-17150e99dcf7?auto=format&fit=crop&w=1200&q=80",
    icon: "CircleDot",
  },
  {
    title: "Massages",
    subtitle: "Hot stone · Deep tissue · Swedish · Balinese",
    image:
      "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5?auto=format&fit=crop&w=1200&q=80",
    icon: "Hand",
  },
  {
    title: "Packs",
    subtitle: "Mud · Neem · Wet sheet · Local packs",
    image:
      "https://images.unsplash.com/photo-1532092367580-3bd5bc78dd9d?auto=format&fit=crop&w=1200&q=80",
    icon: "Leaf",
  },
  {
    title: "Ozone Therapy",
    subtitle: "Prolozone · Ozone insufflation · MAH",
    image:
      "https://images.pexels.com/photos/9146381/pexels-photo-9146381.jpeg?auto=compress&cs=tinysrgb&w=1200",
    icon: "Wind",
  },
];

export const FOUNDERS = [
  {
    name: "Er. Narendra D.R",
    qual: "B.E (Instrumentation Technology)",
    role: "Founder",
  },
  {
    name: "Mrs. Kavitha Narendra",
    qual: "BCom, MA (Kannada)",
    role: "Co-Founder",
  },
  { name: "Dr. Gandhi D.N", qual: "BNYS", role: "Co-Founder" },
  { name: "Dr. Bheemavva A", qual: "BNYS", role: "Operational Doctor" },
  {
    name: "Mahesh Kumar Y.V",
    qual: "Medical Administration",
    role: "Medical Admin",
  },
];

export const VISITING = [
  {
    name: "Dr. Vasanth Kumar",
    qual: "MBBS MD (Anaesthesiology)",
  },
  { name: "Dr. Chikkanna", qual: "MBBS" },
  { name: "Dr. Srinivas", qual: "BAMS" },
];

export const PHILOSOPHY_POINTS = [
  {
    n: "01",
    text: "Provide authentic naturopathic care rooted in science and tradition",
  },
  {
    n: "02",
    text: "Reconnect each person to their own innate healing intelligence",
  },
  {
    n: "03",
    text: "Holistic healing — physical, mental, emotional and spiritual",
  },
];

export const PHILOSOPHY_BODY = [
  "Naturopathy harnesses the healing power of nature to restore equilibrium in the body, mind and spirit through non-invasive, evidence-based therapies.",
  "Our treatments are individualised. Every consultation begins with listening — understanding your story, your body, your goals.",
  "We integrate traditional practices like marma therapy and hydrotherapy with contemporary modalities like ozone therapy and physiotherapy.",
];

export const TESTIMONIALS = [
  {
    name: "Gangamma",
    age: "85 years",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/48k0qklo_IMG-20260807-WA0028.jpg",
    imagePos: "80% 30%",
    headline: "From 15 years of medication to a medicine-free life",
    conditions: [
      "Lower abdominal pain",
      "Urinary infections",
      "Incontinence",
      "Knee pain",
      "Neural disorders",
    ],
    stats: [
      { label: "Years on medication", before: "13+", after: "0" },
      { label: "Monthly expense", before: "₹5,000", after: "₹0" },
      { label: "Recovery", before: "—", after: "2–3 months" },
    ],
    quote:
      "After years of allopathy and nearly ₹10–12 lakhs spent, my mother finally listened at Tatva. With counseling, a detoxification plan and a daily diet, she recovered in just 2–3 months. At 85, she is medication-free for over a year.",
    author: "Shared by her son, Narendra",
    accent: "#c4a257",
  },
  {
    name: "Harish",
    age: "Diabetes healed in 4 weeks",
    location: "Karnataka",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/wzyrsyja_IMG-20260807-WA0037.jpg",
    imagePos: "8% 22%",
    headline: "His body healed itself of diabetes in four weeks",
    conditions: ["Type 2 Diabetes", "High HbA1c", "Insulin dependence"],
    stats: [
      { label: "HbA1c (Jul 20)", before: "15.0", after: "—" },
      { label: "Fasting (Aug 14)", before: "—", after: "112" },
      { label: "Post-meal (Aug 29)", before: "—", after: "116" },
    ],
    quote:
      "Harish began with an HbA1c of 15. Two weeks of diet with insulin brought his fasting to 112 and post-meal to 190. Four weeks later, on diet alone, his numbers settled at 102 and 116. He remains free of all medication today.",
    author: "Patient story",
    accent: "#2c7a4a",
  },
  {
    name: "Hemalatha",
    age: "70 years",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/xjq9yeyu_IMG-20260807-WA0029.jpg",
    imagePos: "6% 20%",
    headline: "Nine months to a completely normal life — zero medication",
    conditions: [
      "Cellulitis & Thrombus",
      "Diabetes (36u insulin)",
      "CKD (creatinine 4.5)",
      "Urine infection",
    ],
    stats: [
      { label: "Insulin per day", before: "36 u", after: "0 u" },
      { label: "Sugar levels", before: "250–400", after: "120–150" },
      { label: "Creatinine", before: "4.5", after: "2.0" },
    ],
    quote:
      "After ₹4 lakhs of care with little improvement, she surrendered to nature cure at Tatva Vaidika Grama. Within four days, sugar reduced to 150 without medication. Nine months later she is living a completely normal life.",
    author: "Patient story",
    accent: "#1b5e3a",
  },
  {
    name: "Mr Manjunath",
    age: "68 years",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/5kpd86wq_IMG-20260807-WA0036.jpg",
    imagePos: "20% 30%",
    headline: "From chemo fatigue to walking miles again",
    conditions: [
      "Prostate cancer",
      "Lymph node swelling",
      "Pedal edema",
      "Insomnia",
    ],
    stats: [
      { label: "Walking (Week 1)", before: "0", after: "1 mile" },
      { label: "Walking (Week 4)", before: "0", after: "2–3 miles / day" },
      { label: "Night sleep", before: "None", after: "Restored" },
    ],
    quote:
      "After surgery and chemo, he lived with total body pain and could barely walk a few feet. Four weeks of natural diet, yoga, pranayama and meditation later — swelling reduced, sleep returned, and he was walking miles daily again.",
    author: "Shared by his daughter, Dr Sushma",
    accent: "#c4a257",
  },
  {
    name: "Nanjamma",
    age: "82 years",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/jjhs5q40_IMG-20260807-WA0030.jpg",
    imagePos: "18% 30%",
    headline: "A hip fracture healed at 82 — without surgery",
    conditions: [
      "Hip bone fracture",
      "Surgery ruled out",
      "3 months sitting only",
    ],
    stats: [
      { label: "Week 1", before: "Sitting only", after: "Slept flat" },
      { label: "Week 2", before: "—", after: "Walker steps" },
      { label: "Month 1", before: "Pain", after: "No pain" },
    ],
    quote:
      "Surgery was ruled out at 82. With nature's diet and daily supervision, she slept flat by week one, walked with a walker by week two, and lived pain-free for four more happy years.",
    author: "Family story",
    accent: "#2c7a4a",
  },
  {
    name: "Mrs Prathichi",
    age: "42 years",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/1owun76x_IMG-20260807-WA0035.jpg",
    imagePos: "50% 50%",
    headline: "From bed-ridden to running in 12 weeks",
    conditions: [
      "Breast cancer",
      "Spine & brain metastasis",
      "Post-radiation bed-ridden",
    ],
    stats: [
      { label: "Day 4", before: "Bed-ridden", after: "Walker" },
      { label: "Day 10", before: "—", after: "Walking solo" },
      { label: "Week 12", before: "—", after: "Running" },
    ],
    quote:
      "After breast cancer surgery and brain radiation she was totally bed-ridden. Stage by stage — walker on day 4, walking independently by day 10, surya namaskar in week 3, dancing in week 8, and running by week 12. Zero medication, only natural food and pranayama.",
    author: "Recovery journey",
    accent: "#c4a257",
  },
  {
    name: "Ramesh",
    age: "36 years",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/e6pa7e7z_IMG-20260807-WA0034.jpg",
    imagePos: "30% 40%",
    headline: "Liver cancer symptoms reversed in four weeks",
    conditions: [
      "Alcoholic liver cirrhosis",
      "Liver cancer",
      "Transplant advised",
    ],
    stats: [
      { label: "Abdominal pain", before: "Severe", after: "Gone" },
      { label: "Vomiting", before: "Frequent", after: "Resolved" },
      { label: "Breathlessness", before: "Present", after: "Cleared" },
    ],
    quote:
      "Alcoholic liver cirrhosis had turned into liver cancer with no option other than transplant. Within four weeks of natural food, yoga, pranayama and meditation practiced diligently, his symptoms of abdominal pain, vomiting, indigestion and breathlessness had cleared.",
    author: "Patient story",
    accent: "#2c7a4a",
  },
  {
    name: "Satya Prasad",
    age: "2.5 years old",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/5d2agcmk_IMG-20260807-WA0033.jpg",
    imagePos: "50% 55%",
    headline: "From ICU to normal in just 10 days",
    conditions: [
      "Hypoxia brain injury",
      "Epileptic attacks",
      "PEG feeding tube",
    ],
    stats: [
      { label: "Before care", before: "1.5 months in ICU", after: "—" },
      { label: "Breathing", before: "Barely", after: "Normal" },
      { label: "Recovery", before: "—", after: "10 days" },
    ],
    quote:
      "A 2.5-year-old with hypoxia brain injury and epileptic attacks who was on a PEG feeding tube. Post-surgery he was in ICU for 1.5 months with no improvement, barely breathing. Natural diet with doctors' supervision brought him from ICU to normal in ten days.",
    author: "Family story",
    accent: "#1b5e3a",
  },
  {
    name: "Mrs Vimala Kumar",
    age: "Breast cancer recovery",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/gc4anngg_IMG-20260807-WA0031.jpg",
    imagePos: "12% 40%",
    headline: "From bed-ridden to walking freely in four weeks",
    conditions: [
      "Primary breast cancer",
      "Spine metastasis",
      "Full-body edema",
      "Complete bed-ridden",
    ],
    stats: [
      { label: "Day 4", before: "Full edema", after: "Reducing" },
      { label: "Week 1", before: "Bed-ridden", after: "Bending & picking" },
      { label: "Week 4", before: "Needed 2 helpers", after: "Getting up alone" },
    ],
    quote:
      "After both-breast surgery and spinal radiation, she was fully bed-ridden with total-body edema and needed two people to do anything. Natural diet, yoga, pranayama and meditation reduced her pain by 80% in the first week, and by week four she was rising from the floor unaided.",
    author: "Recovery journey",
    accent: "#c4a257",
  },
  {
    name: "Mrs Vinaya",
    age: "55 years",
    location: "Bengaluru",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_content-extractor-88/artifacts/14zazz42_IMG-20260807-WA0032.jpg",
    imagePos: "20% 40%",
    headline: "Lymphoma recovery — sleep, appetite and strength restored",
    conditions: [
      "Lymphoma cancer",
      "Post-chemo weakness",
      "Insomnia & no appetite",
    ],
    stats: [
      { label: "Day 3", before: "No appetite", after: "Hunger returned" },
      { label: "Week 2", before: "Dark skin", after: "Colour restored" },
      { label: "Sleep", before: "None", after: "Restful" },
    ],
    quote:
      "After a couple of rounds of chemotherapy she was fully weak — unable to walk, with no appetite, no sleep and constant vomiting. With natural diet, yoga, pranayama and meditation her hunger returned by day three, and by the end of week two her sleep and skin colour were fully restored.",
    author: "Shared with her husband, Mr Dinesh Hegde",
    accent: "#2c7a4a",
  },
];
